/**
 * Factory for creating AddServiceOrderJobs requests.
 * Only adds jobs that have NOT yet been transferred to DMS.
 */
import {ICase, IUser} from '@service-and-repairs/awpintegrationlib';
import {AddServiceOrderJobsRequest} from "./add-service-order-jobs-request";
import {AwpDmsInterfaceFactoryUtils} from "../../rest-api/awp-dms-interface-factory-utils";
import {AddServiceOrderJobsRequestBody} from "./add-service-order-jobs-request-body";
import {ServiceOrderJob} from "../order";

export class AwpDmsInterfaceAddOrderJobsRequestFactory {

  createRequest(user: IUser, serviceCase: ICase): AddServiceOrderJobsRequest {
    const req = new AddServiceOrderJobsRequest();
    req.functionalHeader = AwpDmsInterfaceFactoryUtils.createFunctionalHeader(serviceCase);
    req.technicalHeader = AwpDmsInterfaceFactoryUtils.createTechnicalHeaderInRequest(
      'awp-dms-add-service-order-jobs-request',
      '1.1.0'
    );
    req.userInformation = AwpDmsInterfaceFactoryUtils.createUserInformation(user);
    req.body = this.createRequestBody(serviceCase);
    return req;
  }

  createRequestBody(serviceCase: ICase): AddServiceOrderJobsRequestBody {
    const body = new AddServiceOrderJobsRequestBody();
    body.dmsServiceOrderId = serviceCase.getDmsOrderNumber();
    body.externalId = serviceCase.getExternalId();
    body.jobList = this.createJobList(serviceCase);
    return body;
  }

  /**
   * Creates job list containing only jobs that have NOT yet been transferred to DMS.
   * Jobs that are frozen after DMS transfer are excluded.
   */
  createJobList(serviceCase: ICase): ServiceOrderJob[] {
    const currencyCode = serviceCase.getCurrencyCode();
    return serviceCase.getJobs()
      .filter(job => !job.getIsFrozenAfterDmsTransfer())
      .map(job => AwpDmsInterfaceFactoryUtils.createServiceOrderJob(job, currencyCode));
  }
}
